'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React, {Fragment} from 'react';
import IonSpinner from '../../../_libs/reactionic/src/components/ionSpinner';
import {Link} from '../../../app/components/Link';
import {BreadcrumbType} from '../../../core-utilities/enums/BreadcrumbType';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {Button} from '../../buttons/Button';


export function BaseNavigationBreadcrumbView(props) {
  const path = props.path;

  if (!path) {
    return (
      <div className="NavigationBreadcrumb__placeholder">
        <IonSpinner icon="dots" />
      </div>
    );
  }

  const pathLength = path.length;
  if (pathLength === 1) {
    return renderOne(path[0]);

  } else if (props.containerWidth === props.availableWidth) {
    return (
      <Fragment>
        {renderEllipsis(props)}
        {renderSeparator()}
        {renderOne(path[pathLength - 1])}
      </Fragment>
    );

  } else if (pathLength === 2) {
    return (
      <Fragment>
        {renderOne(path[0])}
        {renderSeparator()}
        {renderOne(path[1])}
      </Fragment>
    );

  } else {
    return (
      <Fragment>
        {renderOne(path[0])}
        {renderSeparator()}
        {renderEllipsis(props)}
        {renderSeparator()}
        {renderOne(path[pathLength - 1])}
      </Fragment>
    );
  }
}

function renderOne(crumb, customLinkClassName) {
  const linkClassName = customLinkClassName || "NavigationBreadcrumb__link";
  return (
    <Link
      key={crumb.id}
      className={linkClassName}
      activeClassName={`${linkClassName}_active`}
      activatedClassName={`${linkClassName}_activated`}
      to={crumb.to}
      toParams={crumb.toParams}
    >
      {crumb.label}
    </Link>
  );
}

function renderSeparator() {
  return (
    <span className="NavigationBreadcrumb__separator">
      {' / '}
    </span>
  );
}

function renderEllipsis(props) {
  return (
    <div className="NavigationBreadcrumb__ellipsisWrapper">
      <Button
        className="NavigationBreadcrumb__ellipsis"
        label={String.fromCharCode(0x2026)}
        setButtonRef={props.setEllipsisButtonRef}
        onClick={props.onClickEllipsis}
      />
      {renderDropdown(props)}
    </div>
  );
}

function renderDropdown(props) {
  return (
    <div className="NavigationBreadcrumb__dropdown__wrapper">
      <div
        className="NavigationBreadcrumb__dropdown__spacer"
        style={{ width: 10 }}
      />
      <div
        className={classNames(
          "NavigationBreadcrumb__dropdown",
          {"NavigationBreadcrumb__dropdown_show": props.showDropdown})}
      >
        {props.path.map(crumb => (
          <div className="NavigationBreadcrumb__dropdown__labeledBlock">
            <div className="NavigationBreadcrumb__dropdown__label">
              {getTypeLabel(crumb.type, props)}
            </div>
            {renderOne(crumb, "NavigationBreadcrumb__dropdown__link")}
          </div>
        ))}
      </div>
    </div>
  );
}

BaseNavigationBreadcrumbView.propTypes = {
  path: T.arrayOf(T.shape({
    id: T.string,
    label: T.string,
    to: T.string,
    type: T.string,
    toParams: T.object,
  })),
  availableWidth: T.number,
  containerWidth: T.number,
  windowWidth: T.number,
  showDropdown: T.bool,
  setEllipsisButtonRef: T.func,

  onClickEllipsis: T.func,

  organizationLabel: T.string,
  projectLabel: T.string,
  assetLabel: T.string,
  taskLabel: T.string,
  requirementLabel: T.string,
};

export const NavigationBreadcrumbView = I18nComponent(BaseNavigationBreadcrumbView, [
  {code: 'navigation.organization.label', prop: 'organizationLabel'},
  {code: 'navigation.project.label', prop: 'projectLabel'},
  {code: 'navigation.asset.label', prop: 'assetLabel'},
  {code: 'navigation.task.label', prop: 'taskLabel'},
  {code: 'navigation.requirement.label', prop: 'requirementLabel'},
]);

function getTypeLabel(type, props) {
  switch (type) {
    case BreadcrumbType.organization:
      return props.organizationLabel;

    case BreadcrumbType.project:
      return props.projectLabel;

    case BreadcrumbType.asset:
      return props.assetLabel;

    case BreadcrumbType.task:
      return props.taskLabel;

    case BreadcrumbType.requirement:
      return props.requirementLabel;

    default:
      return null;
  }
}

/**
 * @typedef {Object} NavigationBreadcrumbPath
 * @property {String} id
 * @property {String} label
 * @property {String} to
 * @property {Object} [toParams]
 */



// WEBPACK FOOTER //
// ./src/js/components/views/NavigationBreadcrumb/NavigationBreadcrumbView.js